import api from './api'

const userManagementService = {
  // Sistem kullanıcısı oluşturma
  async createSystemUser(userData) {
    try {
      const response = await api.post('/user-management/system-user', userData)
      return response.data
    } catch (error) {
      console.error('Sistem kullanıcısı oluşturulurken hata:', error)
      throw error
    }
  },

  // Acente kullanıcısı oluşturma
  async createAgencyUser(userData) {
    try {
      const response = await api.post('/user-management/agency-user', userData)
      return response.data
    } catch (error) {
      console.error('Acente kullanıcısı oluşturulurken hata:', error)
      throw error
    }
  },

  // Taşıyıcı kullanıcısı oluşturma
  async createCarrierUser(userData) {
    try {
      const response = await api.post('/user-management/carrier-user', userData)
      return response.data
    } catch (error) {
      console.error('Taşıyıcı kullanıcısı oluşturulurken hata:', error)
      throw error
    }
  },

  // Kullanıcı listesi getirme
  async getUsers(filters = {}) {
    try {
      const params = new URLSearchParams()
      
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
          params.append(key, filters[key])
        }
      })

      const response = await api.get(`/user-management/users?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Kullanıcı listesi getirilirken hata:', error)
      throw error
    }
  },

  // Tekil kullanıcı getirme
  async getUser(userId) {
    try {
      const response = await api.get(`/user-management/users/${userId}`)
      return response.data
    } catch (error) {
      console.error('Kullanıcı getirilirken hata:', error)
      throw error
    }
  },

  // Kullanıcı güncelleme
  async updateUser(userId, userData) {
    try {
      const response = await api.put(`/user-management/users/${userId}`, userData)
      return response.data
    } catch (error) {
      console.error('Kullanıcı güncellenirken hata:', error)
      throw error
    }
  },

  // Kullanıcı silme (pasifleştirme)
  async deleteUser(userId) {
    try {
      const response = await api.delete(`/user-management/users/${userId}`)
      return response.data
    } catch (error) {
      console.error('Kullanıcı silinirken hata:', error)
      throw error
    }
  },

  // Acente listesi getirme
  async getAgencies() {
    try {
      const response = await api.get('/user-management/agencies')
      return response.data
    } catch (error) {
      console.error('Acente listesi getirilirken hata:', error)
      throw error
    }
  },

  // Taşıyıcı listesi getirme
  async getCarriers() {
    try {
      const response = await api.get('/user-management/carriers')
      return response.data
    } catch (error) {
      console.error('Taşıyıcı listesi getirilirken hata:', error)
      throw error
    }
  }
}

export default userManagementService
